import { axiosApi } from './axios.api';
import { apiErrorMessage } from './ApiError';
import { CategoryType } from '@app/constants/categoriesList';

export interface SearchResultItem {
  id: number;
  label: string;
  sub: string | null;
  url: string;
}

export interface SearchResultCategory {
  category: CategoryType;
  items: SearchResultItem[];
}

export interface SearchResponse {
  results: SearchResultCategory[];
}

export const searchApi = async (
  q: string,
  categories?: CategoryType[],
): Promise<SearchResponse | undefined> => {
  try {
    const params: Record<string, string | string[]> = { q };
    if (categories && categories.length > 0) {
      params['categories[]'] = categories;
    }
    const response = await axiosApi.get<SearchResponse>('/api/search', { params });
    return response.data;
  } catch {
    // Return empty result on error — search failures should not crash the UI
    return { results: [] };
  }
};
